import Vue from "vue";
import Router from "vue-router";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");
const ProductionManagementContainer = () =>
  import("@/containers/ProductionManagementContainer");

const DashboardContainer = () =>
  import("@/containers/DashboardContainer.vue");

// Views
const Dashboard = () => import("@/pages/Dashboard");
const Products = () => import("@/pages/Products");
const Units = () => import("@/pages/Units");
const Company = () => import("@/pages/Company");
const Outsource = () => import("@/pages/Outsource");
const Post = () => import("@/pages/Post");
const Features = () => import("@/pages/Features");
const Users = () => import("@/pages/Users");
const Voucher = () => import("@/pages/Voucher");
const Documents = () => import("@/pages/Documents");
const Order = () => import("@/pages/Order");
const OrderDetail = () => import("@/pages/OrderDetail");
const PurchaseOrder = () => import("@/pages/PurchaseOrder");
const PurchaseOrderDetail = () => import("@/pages/PurchaseOrderDetail");
const VoucherType = () => import("@/pages/VoucherType");
const ProductPatterns = () => import("@/pages/ProductPatterns");
const AccountsTitles = () => import("@/pages/AccountsTitles");
const cashier = () => import("@/pages/Accounting/cashier");
const accountsGroup = () => import("@/pages/Accounting/accountsGroup");
const journal = () => import("@/pages/Accounting/journal");
const CategoryAccounts = () => import("@/pages/Accounting/CategoryAccounts");
const CostCenters = () => import("@/pages/Accounting/CostCenters");
const ActivityType = () => import("@/pages/Accounting/ActivityType");
const users = () => import("@/pages/Accounting/users");
const PettyCash = () => import("@/pages/Accounting/PettyCash");
const groupUsers = () => import("@/pages/Accounting/groupUsers");
const CheckBook = () => import("@/pages/Accounting/CheckBook");
const AccountingDocumentsList = () => import("@/pages/AccountingDocumentsList");
const AccountingDocuments = () => import("@/pages/AccountingDocuments");
const Banks = () => import("@/pages/Banks");
const BankAccount = () => import("@/pages/BankAccount");
const Login = () => import("@/pages/Login.vue");
const Access = () => import("@/pages/Access.vue");
const AccessDenied = () => import("@/pages/AccessDenied.vue");
const Home = () => import("@/pages/Home.vue");
const Kardex = () => import("@/pages/Kardex.vue");
const KardexCosts = () => import("@/pages/KardexCosts.vue");
const WorksHome = () => import("@/pages/taskFlow/WorksHome.vue");
const WorkProblems = () => import("@/pages/taskFlow/WorkProblems.vue");
const Orders = () => import("@/pages/taskFlow/Orders.vue");
const ManageOrders = () => import("@/pages/ManageOrders.vue");
const ManageBuyOrders = () => import("@/pages/ManageBuyOrders.vue");
const MermaidFlowchart = () => import("@/pages/AndroidPage/MermaidFlowchart.vue");
const CustomerOrder = () => import("@/pages/taskFlow/CustomerOrder.vue");
const Patterns = () => import("@/pages/taskFlow/Patterns.vue");
const StoreOrderStatus = () => import ("@/pages/StoreOrderStatus.vue");
const CustomerWorks = () => import ("@/pages/taskFlow/CustomerWorks.vue");
const ProductsList = () => import ("@/pages/ProductsList.vue");
const ProductsListIRR = () => import ("@/pages/ProductsListIRR.vue");
const ProductsListWithOutStock = () => import ("@/pages/ProductsListWithOutStock.vue");
const ProductsListWithOutStockIRR = () => import ("@/pages/ProductsListWithOutStockIRR.vue");
const KardexReceive = () => import ("@/pages/KardexReceive.vue");
const Persons = () => import ("@/pages/Persons.vue");
const CreateWork = () => import ("@/pages/CreateWork.vue");
const ChangeRole = () => import ("@/pages/ChangeRole.vue");
const PrintVoucher = () => import ("@/pages/PrintVoucher.vue");
const PrintOrder = () => import ("@/pages/PrintOrder.vue");
const CompanySetting = () => import ("@/pages/CompanySetting.vue");


Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "open active",
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: "/dashboard",
      controlName: "dashboard",
      component: DashboardContainer,
      children: [
        {
          path: "/dashboard",
          name: "داشبورد",
          component: Dashboard,
          controlName: "Dashboard"
        },
      ]
    },
    // {
    //   path: "/production-management",
    //   redirect: "/production-management/orders-list",
    //   name: "مدیریت تولید",
    //   controlName: "order",
    //   component: ProductionManagementContainer,
    //   children: [
    //     {
    //       path: "orders-list",
    //       name: "لیست سفارشات",
    //       component: () => import("@/pages/production-management/OrdersList"),
    //       controlName: "order",
    //       props: {
    //         accesses: [
    //           {id: "show-table", title: "نمایش جدول"},
    //           {id: "go-to-tasks-page", title: "رفتن به صفحه دوم"},
    //           {id: "test", title: "تست"}
    //         ]
    //       }
    //     },
    //     {
    //       path: "supply/:id",
    //       name: "سفارشات محصول",
    //       component: () => import("@/pages/production-management/Supply"),
    //       controlName: "order"
    //     },
    //
    //   ]
    // },
    /*   {
         path: "/dashboard",
         redirect: "/dashboard",
         controlName: Dashboard,
         component: DashboardContainer,
         children: [
           {
             path: "dashboard",
             name: "داشبورد",
             component: () => import("@/pages/Dashboard.vue"),
             controlName: Dashboard
           }
         ]
       },*/
    /*    {
          path: "/dashboard",
          name: "داشبورد",
          component: Dashboard,
          controlName: Dashboard
        }*/

    {
      path: "/login",
      name: "ورود",
      component: Login,
      controlName: "auth"
    },
    {
      path: "/ChangeRole",
      url: "/ChangeRole",
      name: "تغییر کاربر",
      // component: () => import("@/pages/ChangeRole.vue"),
      component: ChangeRole,
      controlName: "auth"
    },


    {
      path: "/",
      redirect: "home",
      name: "خانه",
      component: DefaultContainer,
      children: [

        // base information first child route

        {
          path: "/bi-access",
          name: "سمتها",
          component: () => import("@/pages/wage/base-information/Bi-Access.vue"),
          controlName: "bi-access"
        },
        {
          path: "/supply/:id",
          name: "تامین سفارش مشتری (برای تغییر سفارشات کارتها را جابجا کنید)",
          component: () => import("@/pages/Supply"),
          controlName: "products"
          // controlName: "order"
        },
        {
          path: "/comming-soon",
          name: "در حال طراحی",
          component: () => import("@/pages/CommingSoon.vue"),
          controlName: "access"
        },
        {
          path: "/user-accesses",
          name: "دسترسی ها",
          component: () => import("@/pages/UserAccesses"),
          controlName: "access"
        },
        {
          path: "home",
          name: "خوش آمدید",
          component: Home
          // controlName: "auth"
        },

        {
          path: "access-denied",
          name: "عدم دسترسی",
          component: AccessDenied
        },
        {
          path: "users",
          name: "کاربر ها",
          component: Users,
          controlName: "users"
        },
        {
          path: "persons",
          name: "اشخاص",
          component: Persons,
          controlName: "PersonActivityTypes"
        },
        {
          path: "products",
          name: "محصولات",
          component: Products,
          controlName: "products",
          props: {accesses: ["create", "edit"]}
        },
        {
          path: "units",
          name: "واحدها",
          component: Units,
          controlName: "units"
        },
        {
          path: "company",
          name: "کارگاه/دستگاه",
          component: Company,
          controlName: "company"
        },
        {
          path: "outsource",
          name: "شرکت های خارجی",
          component: Outsource,
          controlName: "outsource"
        },
        {
          path: "/workProblems",
          name: "وقفه های کار",
          component: WorkProblems,
          controlName: "WorkProblems"
        },
        {
          path: "/damageType",
          name: "علل ضایعات",
          component: () => import("@/pages/taskFlow/DamageType.vue"),
          controlName: "damageType"
        },
        {
          path: "features",
          name: "ویژگی ها",
          component: Features,
          controlName: "features"
        },
        {
          path: "post",
          name: "نقش ها",
          component: Post,
          controlName: "post"
        },
        {
          path: "voucher-type",
          name: "نوع حواله",
          component: VoucherType,
          controlName: "documenttypes"
        },
        {
          path: "product-patterns",
          name: "الگوهای تولید",
          component: ProductPatterns,
          controlName: "patterns"
        },
        {
          path: "store-order-status",
          name: "وضعیت سفارش",
          component: StoreOrderStatus,
          controlName: "store"
        },
        {
          path: "companySetting",
          name: "تنظیمات",
          component: CompanySetting,
          controlName: "store"
        },
        {
          path: "voucher",
          name: "رسید",
          component: Voucher,
          controlName: "voucher",
          props: true
        },
        {
          path: "documents",
          name: "اسناد انبار",
          component: Documents,
          controlName: "voucher"
        },
        {
          path: "kardex",
          name: "کارتکس کالا",
          component: Kardex,
          controlName: "kardex"
        },
        {
          path: "kardexCosts",
          name: "کارتکس کالا",
          component: KardexCosts,
          controlName: "kardex"
        },
        {
          path: "productsList",
          name: "لیست موجودی کالاها",
          component: ProductsList,
          controlName: Products
        },
        {
          path: "productsListWithOutStock",
          name: "لیست کالاها",
          component: ProductsListWithOutStock,
          controlName: Products
        },
        {
          path: "productsListIRR",
          name: "لیست موجودی کالاها",
          component: ProductsListIRR,
          controlName: Products
        },
        {
          path: "printVoucher",
          url: "/printVoucher",
          name: "پرینت ووچر",
          component: PrintVoucher,
          controlName: Orders
        },
        {
          path: "printOrder",
          url: "/printOrder",
          name: "پرینت سفارش",
          component: PrintOrder,
          controlName: Orders
        },
        {
          path: "productsListWithOutStockIRR",
          name: "لیست کالاها",
          component: ProductsListWithOutStockIRR,
          controlName: Products
        },
        {
          path: "kardexReceive",
          name: "گردش درخواست کننده",
          component: KardexReceive,
          controlName: Kardex
        },

        {
          path: "order",
          name: "سفارشات مشتری",
          component: Order,
          controlName: "orders"
        },
        {
          path: "order-detail",
          name: "جزئیات سفارش فروش",
          component: OrderDetail,
          controlName: "orders",
          props: true
        },
        {
          path: "purchase-order",
          name: "سفارشات خرید-تامین",
          component: PurchaseOrder,
          controlName: "purchaseOrders"
        },
        {
          path: "purchase-order-detail",
          name: "جزئیات سفارش خرید",
          component: PurchaseOrderDetail,
          controlName: "purchaseOrders",
          props: true
        },
        {
          path: "accounts-titles",
          name: "سرفصل حساب ها",
          component: AccountsTitles,
          controlName: "accounttitle"
        },
        {
          path: "/Accounting/cashier",
          name: "صندوق",
          component: cashier,
          controlName: "cashier"
        },
        {
          path: "/Accounting/accountsGroup",
          name: "گروه حساب ها",
          component: accountsGroup,
          controlName: "accountsGroup"
        },
        {
          path: "/Accounting/CostCenters",
          name: "مراکز هزینه",
          component: CostCenters,
          controlName: "CostCenters"
        },
        {
          path: "/Accounting/journal",
          name: "دفتر روزنامه",
          component: journal,
          controlName: "journal"
        },
        {
          path: "/Accounting/ActivityType",
          name: "عنوان فعالیت",
          component: ActivityType,
          controlName: "ActivityType"
        },
        {
          path: "/Accounting/CategoryAccounts",
          name: "حساب های دسته بندی",
          component: CategoryAccounts,
          controlName: "CategoryAccounts"
        },
        {
          path: "/Accounting/users",
          name: "اشخاص",
          component: users,
          controlName: "users"
        },
        {
          path: "/Accounting/PettyCash",
          name: "تنخواه گردان",
          component: PettyCash,
          controlName: "PettyCash"
        },
        {
          path: "/Accounting/groupUsers",
          name: "گروه های اشخاص",
          component: groupUsers,
          controlName: "groupUsers"
        },
        {
          path: "/Accounting/CheckBook",
          name: "دسته چک های بانکی",
          component: CheckBook,
          controlName: "CheckBook"
        },
        {
          path: "accounting-documents-list",
          name: "اسناد حسابداری",
          component: AccountingDocumentsList,
          controlName: "accountingvouchers"
        },
        {
          path: "accounting-documents",
          name: "سند حسابداری",
          component: AccountingDocuments,
          controlName: "accountingvouchers",
          props: true
        },
        {
          path: "banks",
          name: "بانک ها",
          component: Banks,
          controlName: "banks"
        },
        {
          path: "bank-accounts",
          name: "حساب های بانکی",
          component: BankAccount,
          controlName: "accounts"
        },
        {
          path: "access",
          name: "سمت ها",
          component: Access,
          controlName: "access"
        },
        // patterns for task-flow
        {
          path: "works-home",
          name: "کارگاه",
          component: WorksHome,
          controlName: " works-home"
        },
        {
          path: "/patterns",
          name: "الگو گذاری",
          component: Patterns,
          controlName: "patterns"
        },

        {
          path: "/orders",
          name: "سفارشات",
          component: Orders,
          controlName: "orders"
        },
        {
          path: "/planning-orders",
          name: "برنامه ریزی سفارشات",
          component:  () => import("@/pages/production-management/PlanningOrders.vue"),
          controlName: "orders"
          // path: "/manage-orders",
          // name: "وضعیت سفارشات مشتری",
          // component: ManageOrders,
          // controlName: "orders"
        },
        {
          path: "/manage-buy-orders",
          name: "وضعیت سفارشات خرید",
          component: ManageBuyOrders,
          controlName: "orders"
        },
        {
          path: "/customerOrders",
          name: "پیگیری سفارشات",
          component: CustomerOrder,
          controlName: "CustomerOrder"
        },
        {
          path: "/customerWorks",
          name: "کارها",
          component: CustomerWorks,
          controlName: "works"
        },
        {
          path: "/chart",
          component: MermaidFlowchart,
          controlName: "chart"
        },
        {
          path: "/createWork",
          name: "کار جدید",
          component: CreateWork,
          controlName: "works"
        },
        {
          path: "/allcompanyproducts",
          url: "/allcompanyproducts",
          name: "موجودی کالا در تمام انبارها",
          component: () => import("@/pages/production-management/AllCompanyProducts.vue"),
          // component: () => import("@/pages/AllCompanyProducts.vue"),
          // component: ChangeRole,
          controlName: "auth"
        },
        {
          path: "/timeSheet",
          url: "/timeSheet",
          name: "روزهای کاری",
          component: () => import("@/pages/production-management/TimeSheet.vue"),
          // component: () => import("@/pages/AllCompanyProducts.vue"),
          // component: ChangeRole,
          controlName: "auth"
        },
        {
          path: "/shifting",
          url: "/shifting",
          name: "تعریف شیفت",
          component: () => import("@/pages/production-management/Shifting.vue"),
          // component: () => import("@/pages/AllCompanyProducts.vue"),
          // component: ChangeRole,
          controlName: "auth"
        },
        {
          path: "/totalcompanyplanning",
          url: "/totalcompanyplanning",
          name: "ظرفیت زمانی کارگاه ها",
          component: () => import("@/pages/production-management/TotalCompanyPlanning.vue"),
          // component: () => import("@/pages/AllCompanyProducts.vue"),
          // component: ChangeRole,
          controlName: "auth"
        },
        {
          path: "/companyplanning",
          url: "/companyplanning",
          name: "ظرفیت زمانی کارگاه",
          component: () => import("@/pages/production-management/CompanyPlanning.vue"),
          controlName: "auth"
        },
        {
          path: "/planning-orders",
          name: "برنامه ریزی سفارشات",
          component:  () => import("@/pages/production-management/PlanningOrders.vue"),
          controlName: "orders"
        },
        {
          path: "/planning-manual",
          name: "برنامه ریزی دستوری",
          component:  () => import("@/pages/production-management/PlanningManual.vue"),
          controlName: "orders"
        },
        {
          path: "/raw-planning",
          name: "برنامه ریزی مواد اولیه",
          component:  () => import("@/pages/production-management/RawMaterialPlanning.vue"),
          controlName: "orders"
        },
        {
          path: "/inventory-planning",
          name: "برنامه ریزی بر اساس موجودی",
          component:  () => import("@/pages/production-management/InventoryPlanning.vue"),
          controlName: "orders"
        },
        {
          path: "/workreport-total-program",
          name: "گزارش برنامه و کارکرد",
          component:  () => import("@/pages/WorkReport/Totalprogram.vue"),
          controlName: "orders"
        },
        {
          path: "/workreport-program",
          name: "جزیات گزارش برنامه",
          component:  () => import("@/pages/WorkReport/program.vue"),
          controlName: "orders"
        },
        {
          path: "/randeman",
          name: "گزارش راندمان کارگاه ها",
          component:  () => import("@/pages/WorkReport/randeman.vue"),
          controlName: "orders"
        },
        {
          path: "/workreport-workshop",
          name: "گزارش کار سفارشات",
          component:  () => import("@/pages/WorkReport/workshop.vue"),
          controlName: "orders"
        },
        {
          path: "/workreport-problem",
          name: "توقفهای تولید",
          component:  () => import("@/pages/WorkReport/problem.vue"),
          controlName: "orders"
        },
        {
          path: "/workreport-damage",
          name: "ضایعات تولید",
          component:  () => import("@/pages/WorkReport/damage.vue"),
          controlName: "orders"
        },
        ///////// P M ///////////////////////////////////////////////////
        {
          path: "/devices",
          name: "دستگاه ها",
          component:  () => import("@/pages/PM/Devices.vue"),
          controlName: "orders"
        },
{
          path: "/check-lists",
          name: "چک لیست ها",
          component:  () => import("@/pages/PM/CheckList.vue"),
          controlName: "orders"
        },
{
          path: "/check-services",
          name: "بازدیدها/سرویسها",
          component:  () => import("@/pages/PM/CheckServices.vue"),
          controlName: "orders"
        },
{
          path: "/deviceCheckServices",
          name: "بازدیدهای دستگاه",
          component:  () => import("@/pages/PM/DeviceCheckServices.vue"),
          controlName: "orders"
        },
{
          path: "/report-services",
          name: "گزارشات بازدید",
          component:  () => import("@/pages/PM/ReportServices.vue"),
          controlName: "orders"
        },
{
          path: "/device-report-services",
          name: "گزارش بازدید دستگاه",
          component:  () => import("@/pages/PM/DeviceReportServices.vue"),
          controlName: "orders"
        },
{
          path: "/curve-report-services",
          name: "نمودار بازدید دستگاه",
          component:  () => import("@/pages/PM/CurveReportServices.vue"),
          controlName: "orders"
        },
{
          path: "/pm-voucher",
          name: "سند نکهداری تعمیرات",
          component:  () => import("@/pages/PM/PmVoucher.vue"),
          controlName: "orders"
        },

      ]
    }
  ]
});
export default router;

